const removeRev = doc => {
  const doc2 = Object.assign({}, doc)
  delete doc2._rev
  return doc2
}

module.exports = removeRev
